import { Box } from '@chakra-ui/react';
import { ReactComponent as CheckSquareIcon } from 'assets/icons/check_square.svg';

interface SelectUploadImageIconProps {
  isSelected: Boolean;
}

export const SelectUploadImageIcon = ({ isSelected }: SelectUploadImageIconProps) => {
  return (
    <Box
      display={isSelected ? 'flex' : 'none'}
      _focus={{ display: 'flex' }}
      _hover={{ bgColor: 'font.500' }}
      position='absolute'
      top='2px'
      right='2px'
      data-testid='select-image-upload-icon'
    >
      <CheckSquareIcon color='white' />
    </Box>
  );
};
